import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { 
  Users, Search, Loader2, ChevronRight, BookOpen
} from 'lucide-react';
import { teacherPanelAPI } from '../../services/api';

const TeacherGroups = () => {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetchGroups();
  }, []);

  const fetchGroups = async () => {
    try {
      const response = await teacherPanelAPI.getGroups();
      setGroups(response.data.groups || []);
    } catch (error) {
      console.error('Guruhlarni yuklashda xato:', error);
    } finally {
      setLoading(false);
    }
  };

  const filteredGroups = groups.filter(group => 
    group.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) {
    return (
      <div className="loading-container">
        <Loader2 className="spinner" size={40} />
        <p>Yuklanmoqda...</p>
      </div>
    );
  }

  return (
    <div className="page-container">
      <header className="page-header">
        <div className="page-title">
          <h1><Users size={28} /> Mening guruhlarim</h1>
          <p>Sizga biriktirilgan guruhlar</p>
        </div>
      </header>

      {/* Search */}
      <div className="search-bar">
        <Search size={20} />
        <input 
          type="text" 
          placeholder="Guruhni qidirish..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {/* Groups Grid */}
      {filteredGroups.length === 0 ? (
        <div className="empty-state">
          <Users size={48} />
          <p>Guruhlar topilmadi</p>
        </div>
      ) : (
        <div className="cards-grid">
          {filteredGroups.map(group => (
            <Link 
              key={group.id} 
              to={`/teacher/groups/${group.id}/students`}
              className="group-card"
            >
              <div className="group-card-header">
                <div className="group-icon">
                  <Users size={24} />
                </div>
                <div>
                  <h3>{group.name}</h3>
                  <span className="badge badge-info">{group.course}-kurs</span>
                </div>
              </div>
              
              <div className="group-stats">
                <div className="group-stat">
                  <Users size={16} />
                  <span>{group.students_count || 0} talaba</span>
                </div>
                <div className="group-stat">
                  <BookOpen size={16} />
                  <span>{group.subjects?.length || 0} fan</span>
                </div>
              </div>
              
              {group.subjects?.length > 0 && (
                <div className="group-subjects">
                  <p className="text-muted small">Fanlar:</p>
                  <div className="tags">
                    {group.subjects.slice(0, 3).map(s => (
                      <span key={s.id} className="tag">{s.name}</span>
                    ))}
                    {group.subjects.length > 3 && (
                      <span className="tag more">+{group.subjects.length - 3}</span>
                    )}
                  </div>
                </div>
              )}
              
              <div className="group-card-footer">
                <span>Talabalarni ko'rish</span>
                <ChevronRight size={18} />
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default TeacherGroups;
